import BigNumber from 'bignumber.js';

import { Nullable } from '#/utils/types';

export function changeDirectionView(value: Nullable<BigNumber>) {
  if (value == null) return null;
  return value.isNegative() ? 'down' : 'up';
}
